import { getMailRouteStore } from '../store/MailRouteStore';
import { MailRouteType } from '../schema/MailRouteType';
import { mutatorAction } from 'satcheljs';

/**
 * Set the route store values.
 * The mailRouteStore.routeType would be used to render different screens in MailModule
 */
export const setMailRoute = mutatorAction(
    'setMailRoute',
    (routeType: MailRouteType, itemId: string = null) => {
        const mailRouteStore = getMailRouteStore();
        mailRouteStore.routeType = routeType;
        mailRouteStore.itemId = itemId;
    }
);
